<template>
    <main-content>
        <kt-panel class="no-mb">
            <kt-panel-header>
                <kt-panel-header-toolbar>
                    <ul class="nav nav-pills" role="tablist">
                        <li class="nav-item">
                            <a class="nav-link active" data-toggle="tab" href="#gateways-reports" role="tab" aria-selected="false">
                                {{ $t('reports.gateways.gateways-reports') }}
                            </a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" data-toggle="tab" href="#taxExports-list" role="tab" aria-selected="false">
                                {{ $t('reports.gateways.taxExportsList') }}
                            </a>
                        </li>
                    </ul>
                </kt-panel-header-toolbar>
            </kt-panel-header>
        </kt-panel>
        <kt-panel-body>
            <div class="tab-content">
                <div class="tab-pane active" id="gateways-reports">
                    <gateway-filter :action="filterAction" :exportExcel="exportToExcel"></gateway-filter>
                    <div>
                        <kt-row v-if="$can('read-statistics', 'transaction')">
                            <div class="col-lg-3 col-md-3 col-sm-6">
                                <accounting-statistics
                                        :accountingStatistics="statistics.total_transactions"
                                        :title="$t('reports.gateways.total_transactions')"
                                />
                            </div>
                            <div class="col-lg-3 col-md-3 col-sm-6">
                                <accounting-statistics
                                        :accountingStatistics="statistics.total_wage"
                                        :title="$t('reports.gateways.total_wage')"
                                />
                            </div>
                            <div class="col-lg-3 col-md-3 col-sm-6">
                                <accounting-statistics
                                        :accountingStatistics="statistics.unsettled_balance"
                                        :title="$t('reports.gateways.unsettled_balance')"
                                />
                            </div>
                            <div class="col-lg-3 col-md-3 col-sm-6">
                                <accounting-statistics
                                        :accountingStatistics="statistics.settled_balance"
                                        :title="$t('reports.gateways.settled_balance')"
                                />
                            </div>
                        </kt-row>
                    </div>
                    <kt-datatable  v-bind="datatableProps" ref="datatable"></kt-datatable>
                </div>
                <div class="tab-pane" id="taxExports-list">
                    <taxExports-list></taxExports-list>
                </div>
            </div>
        </kt-panel-body>
    </main-content>
</template>

<script>
import mainContent from '@/components/main-content'
import gatewayFilter from "./components/gateway-filter";
import taxExportsList from "./components/taxExports-list";
import columns from "./datatable/gatewaysColumns";
import { ApiUrl } from '@/common/api.service'
import { AuthorizationHeader } from '@/common/jwt.service'
import axios from "axios";
import statistics from "./components/accounting-statistics";
import {mapGetters} from "vuex";
import $ from "jquery";
import { i18n } from '@/plugins/i18n'
import toastr from "toastr";
import { KTApp } from '@/plugins/core/app'

export default {
    components: {
        'main-content': mainContent,
        'gateway-filter': gatewayFilter,
        'accounting-statistics': statistics,
        'taxExports-list': taxExportsList,
    },
    data() {
        return {
            query: {}
        }
    },
    computed: {
        datatableProps() {
            return {
                id: "gateways_report_datatable",
                data: {
                    type: 'remote',
                    source: {
                        read: {
                            url: ApiUrl.path('reports/gateways'),
                            method: 'GET',
                            headers: AuthorizationHeader,
                            map: function(res) {
                                return res.data.data
                            },
                            params: {
                                query: this.query
                            },
                        },
                    },
                    pageSize: 10,
                    serverPaging: true,
                    serverFiltering: true,
                    serverSorting: true,
                },
                layout: {
                },
                pagination: false,
                sortable: true,
                columns: columns,
            }
        },
        ...mapGetters('reports', [
            'statistics','status'
        ]),
        toastr() {
            toastr.options = {
                closeButton: true,
                positionClass: "toast-bottom-center",
                preventDuplicates: false,
                rtl: false
            }

            return toastr
        }
    },

    methods: {
        filterAction(e, query) {
            this.query = query
            if (this.$refs.datatable.KTDatatable) {
                this.$store.dispatch('reports/fetchGatewaysStatistics', query)
                this.$refs.datatable.reload()
            }
        },
        exportToExcel(e, query){
            this.query = {
                'query': query
            }
            let btn = $('#export_btn')
            KTApp.progress(btn)

            axios({
                url: ApiUrl.path('reports/gateways-excel-export'),
                method: 'GET',
                params: this.query,
                responseType: 'blob',
            }).then(
                response => {
                KTApp.unprogress(btn)

                var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                var fileLink = document.createElement('a');

                fileLink.href = fileURL;
                fileLink.setAttribute('download', 'gateways_reports.xlsx');
                document.body.appendChild(fileLink);

                fileLink.click();
                },
                error => {
                this.toastr.error(i18n.t('reports.tax.failedMessage'))
            });
        },
    },
    mounted() {
        this.$store.dispatch('reports/fetchGatewaysStatistics')
    }
}
</script>

<style>

</style>